import AP from '../config/api.config'

const tokenStorage = {
  getToken () {
    const LocalTime = localStorage.getItem('LocalTime')
    const Golf = localStorage.getItem('Golf')
    const TokenCode = localStorage.getItem('TokenCode')
    if (LocalTime !== null && Golf !== null && TokenCode !== null) {
      return { data: { result: 1, LocalTime: LocalTime, Golf: Golf, TokenCode: TokenCode } }
    } else {
      return { data: { result: '有你妈的token，检测你妈' } }
    }
  },
  removeToken () {
    localStorage.removeItem('LocalTime')
    localStorage.removeItem('Golf')
    localStorage.removeItem('TokenCode')
  },
  testToken () {
    console.log('Get it!')
    return { data: { sCode: 1 } }
  },
  setToken (TokenCode, LocalTime, Golf) {
    localStorage.setItem('TokenCode', TokenCode)
    localStorage.setItem('LocalTime', LocalTime)
    localStorage.setItem('Golf', Golf)
  }
}
export default tokenStorage
